import React, { useState, useRef, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import JoditEditor from "jodit-react";
import { getItemToken } from "../../../Utils/localStorageUtils";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import { toast } from "react-toastify";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import MessageBox from "../../../components/CommonComponents/MessageBox";
import AdminCustomInput from "../../../components/CommonComponents/AdminCustomInput";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import AdminCustomArea from "../../../components/CommonComponents/AdminCustomArea";
import AdminSwitch from "../../../components/CommonComponents/AdminSwitch";
import AdminCustomButton from "../../../components/CommonComponents/AdminCustomButton";
import { slugGenerator } from "../../../components/CommonMethod/CommonMethods";
import AdminBackNavigation from "../../../components/CommonComponents/AdminBackNavigation";
import { IoMdInformationCircle } from 'react-icons/io'
import { FaMagic } from "react-icons/fa";
import AdminAIModal from "../../../components/CommonComponents/AdminAImodal";
import FieldRenderer2 from "../../../CustomFields/FieldRenderer2";
import FieldRenderer from "../../../CustomFields/FieldRenderer";
import saveCustomFieldsStrict from "../../../CustomFields/saveCustomFieldsStrict";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";
import { useMyContext } from "../../../components/Provider/CommonProvider";

const AddLandingPages = (props) => {

  const baseURL = process.env.REACT_APP_Baseurl
  const access_token = localStorage.getItem("access_token");
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${access_token}`,
    Accept: "application/json",
  };
  const { id } = useParams()
  const navigate = useNavigate()

  const [showModal, setShowModal] = useState(false);

  const labelSource = 'landing-page'

  const { fetchRequest, globalImageUplaodAPI } = useMyContext();

  const combinedRef = useRef({
    title: null,
    slug: null,
    content: null,
  });

  const [formData, setFormData] = useState({
    state: "formData",
    title: "",
    slug: "",
    content: "",
    custom_css: "",
    script_content: "",
    bootstrap_link: "",
    status: 0,
    header: 0,
    footer: 0
  })

  const addApi = `${baseURL}/admin/landing-page/store`
  const editApi = `${baseURL}/admin/landing-page/edit`
  const updateApi = `${baseURL}/admin/landing-page/update`
  const labelApi = `${baseURL}/admin/Label-Management/list-source?source=${labelSource}`
  const deleteApi = `${baseURL}/admin/landing-page/delete`
  const generateAISuggestionApi = `${baseURL}/admin/ai-prompt-response`

  const [formDataError, setFormDataError] = useState({ body: "" })
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [showOverlay, setShowOverlay] = useState(false);
  const [loading, setLoading] = useState(true);
  const [customFieldValues, setCustomFieldValues] = useState({});
  const [backgroundImageFile, setBackgroundImageFile] = useState(null);
  const [logoFile, setLogoFile] = useState(null);
  const [mobileImageFile, setMobileImageFile] = useState(null);

  const fetchData = async () => {
    try {
      const response = await axios.get(`${editApi}/${id}`, { headers: headers });
      const result = response?.data?.data;
      setFormData(result)
      setLoading(false)
    } catch (error) {
      console.error(error);
    }
  };

  const handleBackgroundImageChange = async (event) => {
    const file = event.target.files[0];
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

    setFormDataError(prev => ({ ...prev, background_image: "" }));

    if (!file) return;

    if (!allowedTypes.includes(file.type)) {
      setFormDataError(prev => ({
        ...prev,
        background_image: "Only JPG, JPEG, WEBP and PNG files are allowed."
      }));
      setBackgroundImageFile(null);
      combinedRef.current['background_image'].focus();
      return;
    }

    setBackgroundImageFile(file);
  };

  const handleLogoChange = (event) => {
    const file = event.target.files[0];
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

    setFormDataError(prev => ({ ...prev, logo: "" }));

    if (!file) return;

    if (!allowedTypes.includes(file.type)) {
      setFormDataError(prev => ({
        ...prev,
        logo: "Only JPG, JPEG, WEBP and PNG files are allowed."
      }));
      setLogoFile(null);
      combinedRef.current['logo'].focus();
      return;
    }

    setLogoFile(file);
  };

  const handleMobileImageChange = (event) => {
    const file = event.target.files[0];
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg', 'image/webp'];

    setFormDataError(prev => ({ ...prev, mobile_image: "" }));

    if (!file) return;

    if (!allowedTypes.includes(file.type)) {
      setFormDataError(prev => ({
        ...prev,
        mobile_image: "Only JPG, JPEG, WEBP and PNG files are allowed."
      }));
      setMobileImageFile(null);
      combinedRef.current['mobile_image'].focus();
      return;
    }

    setMobileImageFile(file);
  };



  const handleClearLogo = () => {
    setLogoFile(null);
    setFormData(prev => ({ ...prev, logo: null }));
  };



  const handleClearBackgroundImage = () => {
    setBackgroundImageFile(null);
    setFormData(prev => ({ ...prev, background_image: null }));
  };

  const handleClearMobileImage = () => {
    setMobileImageFile(null);
    setFormData(prev => ({ ...prev, mobile_image: null }));
  };



  const handleImageUpload = async (id) => {
    if (!backgroundImageFile) return;

    try {

      const formDataAdd = new FormData();
      const modelName = "AdminLandingPage";
      formDataAdd.append('background_image', backgroundImageFile);
      formDataAdd.append('landing_page_id', id);
      formDataAdd.append('id', id)
      formDataAdd.append('modelName', modelName)
      formDataAdd.append('imageFields[]', 'background_image')
      const response = await fetchRequest({
        method: 'POST',
        url: globalImageUplaodAPI(),
        data: formDataAdd,
      });

      if (response?.data?.status) {
        toast.success("Background image uploaded successfully!");
        setBackgroundImageFile(null);
      } else {
        toast.error(response?.data?.message || "Upload failed");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    }
  };

  const handleLogoUpload = async (id) => {
    if (!logoFile) return;

    try {
      const formDataAdd = new FormData();
      const modelName = "AdminLandingPage";

      formDataAdd.append('logo', logoFile);
      formDataAdd.append('landing_page_id', id);
      formDataAdd.append('id', id);
      formDataAdd.append('modelName', modelName);
      formDataAdd.append('imageFields[]', 'logo');

      const response = await fetchRequest({
        method: 'POST',
        url: globalImageUplaodAPI(),
        data: formDataAdd,
      });

      if (response?.data?.status) {
        toast.success("Logo uploaded successfully!");
        setLogoFile(null);
      } else {
        toast.error(response?.data?.message || "Upload failed");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    }
  };

  const handleMobileImageUpload = async (id) => {
    if (!mobileImageFile) return;

    try {
      const formDataAdd = new FormData();
      const modelName = "AdminLandingPage";

      formDataAdd.append('mobile_image', mobileImageFile);
      formDataAdd.append('landing_page_id', id);
      formDataAdd.append('id', id);
      formDataAdd.append('modelName', modelName);
      formDataAdd.append('imageFields[]', 'mobile_image');

      const response = await fetchRequest({
        method: 'POST',
        url: globalImageUplaodAPI(),
        data: formDataAdd,
      });

      if (response?.data?.status) {
        toast.success("Mobile image uploaded successfully!");
        setMobileImageFile(null);
      } else {
        toast.error(response?.data?.message || "Upload failed");
      }
    } catch (err) {
      toast.error(err?.message || "Something went wrong");
    }
  };





  const handleInput = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prev) => ({
        ...prev,
        [name]: checked ? 1 : 0,
      }));
    }
    if (type === 'text') {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      setFormDataError((prev) => ({
        ...prev,
        [name]: '',
      }));
    }
    if (type === "textarea") {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }


  };

  const handleBlurtitle = () => {
    if (!formData?.slug) {
      generateSlug(formData?.title);
    }
  };

  const generateSlug = async (title) => {
    const slug = await slugGenerator(title)
    setFormData((prev) => ({
      ...prev,
      'slug': slug,
    }));
  };


  const handleInputKeyDowntitle = (event) => {
    if (!formData?.slug) {
      if (event.key === "Enter" || event.key === "Tab") {
        generateSlug(formData?.name);
      }
    }
  };

  const formValidation = () => {
    let formIsValid = true;
    if (!formData?.title) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        title: "Title cannot be empty.",
      }));
      combinedRef.current['title'].focus()
      formIsValid = false;
    } else if (!formData?.slug) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        slug: "Slug cannot be empty.",
      }));
      combinedRef.current['slug'].focus()
      formIsValid = false;
    }
    if (!formData?.content) {
      setFormDataError((prevFormData) => ({
        ...prevFormData,
        content: "content cannot be empty.",
      }));
      combinedRef.current['content'].focus()
      formIsValid = false;
    }
    return formIsValid;
  }


  const handleAdd = async () => {
    const findApi = !id ? addApi : `${updateApi}/${id}`
    const method = !id ? 'POST' : 'POST';
    setShowOverlay(true);
    try {
      const formDataAdd = {};
      for (const key in formData) {
        if (["title", "slug", "content", "custom_css", "script_content", "bootstrap_link", "status", "header", "footer"].includes(key)) {
          formDataAdd[key] = formData[key]
        }
      }
      const response = await axios({ method: method, url: findApi, data: formDataAdd, headers: headers, });
      const result = response?.data;
      const imageId = result.AdminLandingPage.landing_page_id;
      if (result?.status) {
        // save custom field values (strict)
        try {
          const entityId = result?.id || id;
          if (entityId != null) {
            await saveCustomFieldsStrict({ baseURL, headers, entityType: 'landing_page', entityId, values: customFieldValues });
          }
        } catch (e) {
          toast.error(e?.message || 'Failed to save additional fields');
          setShowOverlay(false);
          return;
        }

        if (backgroundImageFile) {
          await handleImageUpload(imageId)
        }

        if (logoFile) {
          await handleLogoUpload(imageId);
        }

        if (mobileImageFile) {
          await handleMobileImageUpload(imageId);
        }

        setShowOverlay(false);
        toast.success(result?.message)
        if (!id) {
          navigate("/landing-page/index");
        }
        else {
          setWithOutRefresh(!withOutRefresh)
        }
      }
      else {
        setShowOverlay(false);
        toast.error(result?.message)
      }
    }
    catch (err) {
      setShowOverlay(false);
      const errorMessage = err?.response?.data?.message
      toast.error(errorMessage)
      console.error("error", err)
    }
  }

  const handleStore = (e) => {
    e.preventDefault()
    if (formValidation()) {
      handleAdd()
    }
  }

  const labelFetch = async () => {
    try {
      setShowOverlay(true)
      const response = await axios.get(`${labelApi}`, { headers: headers });
      const result = response?.data?.label_management
      setLabelDisplay(result)
      setShowOverlay(false)
    }
    catch (err) {
      setShowOverlay(false)
      toast.error(err.response.data.message)

    }
  }

  const confirmToggle = (suggestedText) => {
    if (suggestedText && typeof suggestedText === 'string') {
      setFormData(prev => ({ ...prev, content: suggestedText }));
    }
    setShowModal(false);
  }

  const closeModal = () => {
    setShowModal(false);
  };

  const handleModal = () => {
    setShowModal(true);
  }

  const generateSuggestion = async (promptText, setSuggestion, setLoading) => {
    const trimmedPrompt = promptText?.trim();
    setLoading(true);
    try {
      const response = await axios.post(
        generateAISuggestionApi,
        { prompt: trimmedPrompt },
        { headers }
      );
      if (response.data?.status) {
        setLoading(false);
        setSuggestion(response.data.response);
      } else {
        alert(response.data.message || "Failed to generate suggestion.");
      }
    } catch (error) {
      if (error.response?.status === 401) {
        alert("Token expired or invalid. Please login again.");
      } else {
        console.error(error);
        alert("Error generating suggestion.");
      }
    }
  };

  useEffect(async () => {
    if (id) {
      await fetchData();
    }
    await labelFetch()

  }, [withOutRefresh]);
  return (
    <>
      <AdminBackNavigation path="/landing-page/index" text="Back" />
      {showOverlay && (<Response_Processing></Response_Processing>)}
      <AdminSaveHeader heading={!id ? labelDisplay?.[1]?.title : labelDisplay?.[2]?.title} saveText={!id ? labelDisplay?.[13]?.title : labelDisplay?.[14]?.title} saveMethod={handleStore} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={!id ? labelDisplay?.[3]?.title : formData?.title} />
            <MessageLabel text={labelDisplay?.[4]?.title} className="mandatorySimple" />
            <AdminCustomInput type="text" name="title" value={formData?.title} onChange={handleInput} placeHolder={"Title"} ref={(el) => (combinedRef.current.title = el)} onBlur={handleBlurtitle} onKeyDown={handleInputKeyDowntitle} error={formDataError?.title} />

            <MessageLabel text={labelDisplay?.[5]?.title} />
            <AdminCustomInput type="text" name="slug" value={formData?.slug} ref={(el) => (combinedRef.current.slug = el)} onChange={handleInput} placeHolder={"Slug"} error={formDataError?.slug} />
            {showModal && (<AdminAIModal modalDescription="Suggest AI" modalHeading="Generate Content" modelClose={showModal} sliderClose={closeModal} applySuggestion={confirmToggle} buttonText="Active" generateSuggestion={generateSuggestion} />)}
            <MessageLabel text={"Page Content"} enableAI handleAIModal={handleModal} className="mandatorySimple" />

            <textarea
              className="form-control mb-3"
              rows={6}
              ref={(el) => (combinedRef.current.content = el)}
              value={formData?.content || ""}
              onChange={(e) => {
                setFormData(prev => ({ ...prev, content: e.target.value }));
                setFormDataError(prev => ({ ...prev, content: "" }));
              }}
            ></textarea>
            {formDataError?.content && (< p className="d-flex"><IoMdInformationCircle className='errorred' style={{ width: "17px", height: "16px" }} /> <MessageBox text={`${formDataError?.content}`} classname='errorred mb-2 d-block' /></p>)}

            <div className="card p-3 mt-3">
              {/* <MessageHeading text="Additional Fields" /> */}
              {/* Custom fields */}
              <FieldRenderer2
                pageIdentifier={id ? "landing_page.edit" : "landing_page.create"}
                entityType={"landing_page"}
                entityId={id}
                text="Additional Fields"
              />
              <FieldRenderer
                pageIdentifier={id ? "landing_page.edit" : "landing_page.create"}
                entityType={"landing_page"}
                entityId={id}
                onChange={setCustomFieldValues}
              />
            </div>

          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>

            <MessageHeading text={"Background Image"} />
            <AdminImageUploadZone
              onChange={handleBackgroundImageChange}
              selectedFile={backgroundImageFile}
              uploadedImage={formData?.background_image}
              onDelete={handleClearBackgroundImage}
              name="background_image"
              id={id}
              ref={(el) => (combinedRef.current.background_image = el)}
              error={formDataError?.background_image}
            />

            <MessageHeading text={"Logo"} />
            <AdminImageUploadZone
              onChange={handleLogoChange}
              selectedFile={logoFile}
              uploadedImage={formData?.logo}
              onDelete={handleClearLogo}
              name="logo"
              id={id}
              ref={(el) => (combinedRef.current.logo = el)}
              error={formDataError?.logo}
            />

            <MessageHeading text={"Mobile Responsive Image"} />
            <AdminImageUploadZone
              onChange={handleMobileImageChange}
              selectedFile={mobileImageFile}
              uploadedImage={formData?.mobile_image}
              onDelete={handleClearMobileImage}
              name="mobile_image"
              id={id}
              ref={(el) => (combinedRef.current.mobile_image = el)}
              error={formDataError?.mobile_image}
            />


            <MessageHeading text={"Page Content"} />
            <MessageLabel text={labelDisplay?.[7]?.title} toolMessage={"Please add Script Content  <script>...</script>"} />
            <AdminCustomArea name="script_content" value={formData?.script_content} onChange={handleInput} ref={(el) => (combinedRef.current.script_content = el)} placeHolder={"Enter script content"} rows={5} />
            <MessageLabel text={labelDisplay?.[8]?.title} toolMessage={"Please add custom CSS as <style>...</style>"} />
            <AdminCustomArea name="custom_css" value={formData?.custom_css} onChange={handleInput} ref={(el) => (combinedRef.current.custom_css = el)} placeHolder={"Enter custom css"} rows={5} />
            <MessageLabel text={labelDisplay?.[9]?.title} toolMessage={"Please add Bootstrap or Script Link as <link>.....</link> <script>...</script>"} />
            <AdminCustomArea name="bootstrap_link" value={formData?.bootstrap_link} onChange={handleInput} ref={(el) => (combinedRef.current.bootstrap_link = el)} placeHolder={"Enter bootstrap & script link"} rows={5} />
          </Wrapper>

          <Wrapper>
            <MessageHeading text={labelDisplay?.[10]?.title} />
            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[11]?.title} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'header'} checked={formData?.header == 1} onChange={handleInput} />
              </div>
            </div>

            <div className="d-flex justify-content-between mb-2 ">
              <div className="col-6 col-md-6 pe-2">
                <MessageLabel text={labelDisplay?.[12]?.title} />
              </div>
              <div className="col-6 col-md-6 ps-2 text-end">
                <AdminSwitch name={'footer'} checked={formData?.footer == 1} onChange={handleInput} />
              </div>
            </div>
          </Wrapper>
        </RightWrapper>
        <AdminCustomButton className='px-3 py-1 me-3 me-md-0 ms-md-auto' saveMethod={handleStore} saveText={!id ? labelDisplay?.[13]?.title : labelDisplay?.[14]?.title} />
      </FormContainer>
    </>
  );
};

export default AddLandingPages;